import React from "react";
import { FaWallet } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./FemaleLevelPage.css";
import { formatNumberEn } from "../../utils/digits";
import { ENABLE_REAL_MONEY_PAYOUTS } from "../../config/featureFlags";

export default function FemaleWithdrawCard({
  balance = 0,
  minWithdraw = 2000,
  currency = "",
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Phase PLAY-COMPLIANCE-PAYOUTS-DISABLE: the entire card is a
  // cash-withdrawal entry point - renders nothing while real-money
  // payouts are disabled. All original code below is preserved unchanged
  // (not deleted) for reactivation later.
  if (!ENABLE_REAL_MONEY_PAYOUTS) {
    return null;
  }

  const safeBalance = Number(balance || 0);
  const canWithdraw = safeBalance >= minWithdraw;
  const displayCurrency =
    currency || t("tokens.unit", { defaultValue: "Token" });

  // Phase PLAY-COMPLIANCE-PAYOUTS-DISABLE: original always-navigates
  // behavior is preserved below, gated behind the flag - never navigates
  // to /withdraw-request while real-money payouts are disabled.
  const handleWithdraw = () => {
    if (!ENABLE_REAL_MONEY_PAYOUTS) return;
    navigate("/withdraw-request"); // ✅ دائمًا يفتح
  };

  return (
    <div className="femaleWithdrawCard">
      <div className="withdrawLeft">
        <div className="withdrawIcon">
          <FaWallet /> {/* ✅ دائمًا نفس الأيقونة */}
        </div>

        <div className="withdrawText">
          <h4>
            {t("withdraw.card.title", {
              defaultValue: "السحب",
            })}
          </h4>

          {/* ✅ فقط الرقم بدون جملة طويلة */}
          <p className="withdrawBalanceLine">
            <strong>
              {formatNumberEn(safeBalance)} {displayCurrency}
            </strong>
          </p>

          {/* ✅ رسالة قصيرة جدًا */}
          <p className={`withdrawSubLine ${canWithdraw ? "ready" : ""}`}>
            {!ENABLE_REAL_MONEY_PAYOUTS
              ? t("withdraw.card.payoutsDisabledSubtitle", {
                  defaultValue: "السحب النقدي غير متاح حاليًا",
                })
              : canWithdraw
              ? t("withdraw.card.readySubtitle", {
                  defaultValue: "يمكنكِ السحب الآن ✨",
                })
              : t("withdraw.card.notReadySubtitle", {
                  defaultValue: "تابعي التقدم لفتح السحب",
                })}
          </p>
        </div>
      </div>

      {/* Phase PLAY-COMPLIANCE-PAYOUTS-DISABLE: original always-active
          button preserved, gated behind the flag below. */}
      <button
        className={`withdrawBtn ${ENABLE_REAL_MONEY_PAYOUTS ? "active" : "disabled"}`}
        onClick={handleWithdraw}
        type="button"
        disabled={!ENABLE_REAL_MONEY_PAYOUTS}
        aria-disabled={!ENABLE_REAL_MONEY_PAYOUTS}
      >
        {ENABLE_REAL_MONEY_PAYOUTS
          ? t("withdraw.card.cta", { defaultValue: "طلب سحب" })
          : t("withdraw.card.payoutsDisabledCta", {
              defaultValue: "غير متاح حاليًا",
            })}
      </button>
    </div>
  );
}
